import apiFetch from '../apiFetch'

export default function (serviceId, token, lastAccessDate, orNumber) {
  return apiFetch({ endPoint: `Dossier/Service/${serviceId}/RequestSpareParts`, method: 'PUT', body: orNumber, token: token, lastAccessDate })
}
